import type { UserAccountDetails } from "@/types/account";
import type { UseQueryReturnType } from "@tanstack/vue-query";
import { get } from "lodash-es";

export function useBillingLink(
  user?: globalThis.Ref<UserAccountDetails | null>
): UseQueryReturnType<string, Error> {
  const email = user?.value?.email ? encodeURIComponent(user.value.email) : "";

  const userExists = computed(() => !!user?.value);

  const request = useQuery({
    queryKey: ["account", "stripe-session"],
    queryFn: async () => {
      const response = await useGetRequest<{ stripeSessionUrl: string }>(
        "/account/stripe-session"
      );
      return get(response, "data", null);
    },
    select: res =>
      res ? `${res?.stripeSessionUrl}?${email ? `?prefilled_email=${email}` : ""}` : "",
    staleTime: 1 * MINUTE,
    refetchOnWindowFocus: false,
    enabled: userExists, // we manually trigger this
  });
  return request;
}
